export const jisdai3HasEncoded = [
  '丨',
  '仡',
  '伃',
  '佖',
  '侊',
  '侔',
  '俉',
  '偀',
  '傔',
  '兊',
  '冝',
  '刕',
  '勛',
  '匀',
  '匇',
  '厓',
  '厲',
  '咜',
  '咩',
  '哿',
  '喆',
  '﨏',
  '埇',
  '埈',
  '塚',
  '增',
  '奝',
  '妤',
  '孖',
  '寘',
  '寬',
  '尞',
  '岺',
  '崧',
  '﨑',
  '嵓',
  '嵭',
  '嶸',
  '弴',
  '彅',
  '彧',
  '德',
  '忞',
  '惕',
  '愰',
  '愷',
  '揵',
  '摠',
  '擎',
  '昀',
  '昉',
  '昕',
  '昞',
  '昤',
  '昱',
  '曻',
  '晙',
  '晥',
  '晳',
  '暠',
  '暲',
  '曺',
  '朗',
  '杦',
  '枻',
  '柀',
  '栁',
  '桒',
  '棈',
  '楨',
  '﨔',
  '槢',
  '橫',
  '橳',
  '櫤',
  '毖',
  '汜',
  '沆',
  '洄',
  '涇',
  '涬',
  '淼',
  '湜',
  '澈',
  '濵',
  '瀅',
  '瀨',
  '炅',
  '炫',
  '焏',
  '煆',
  '煇',
  '煜',
  '凞',
  '燁',
  '燾',
  '犾',
  '猪',
  '珉',
  '珖',
  '珣',
  '琇',
  '琦',
  '琪',
  '琮',
  '瑢',
  '璉',
  '璟',
  '甁',
  '甯',
  '畯',
  '皛',
  '皞',
  '皦',
  '睆',
  '硎',
  '神',
  '祥',
  '福',
  '竫',
  '箞',
  '絈',
  '絜',
  '綠',
  '緖',
  '繒',
  '纊',
  '罇',
  '茁',
  '荢',
  '菇',
  '葈',
  '蒴',
  '蕙',
  '﨟',
  '薰',
  '裵',
  '褜',
  '訒',
  '訷',
  '詹',
  '誧',
  '諟',
  '諶',
  '諸',
  '賴',
  '贒',
  '郞',
  '都',
  '鄕',
  '鄧',
  '釗',
  '釤',
  '釥',
  '釭',
  '鈐',
  '鈹',
  '鈺',
  '鈼',
  '鉀',
  '鉸',
  '銈',
  '鋓',
  '鋠',
  '鋿',
  '錡',
  '錥',
  '鍈',
  '鍰',
  '鏆',
  '鏞',
  '隆',
  '隝',
  '霳',
  '霻',
  '靍',
  '靏',
  '顗',
  '顥',
  '馞',
  '驎',
  '魲',
  '魵',
  '鮏',
  '鰀',
  '鵰',
  '黑',
]

export const jisdai4HasEncoded = [
  '伀',
  '侒',
  '侚',
  '倞',
  '倢',
  '偂',
  '偆',
  '偰',
  '劦',
  '劯',
  '匤',
  '咊',
  '垬',
  '夋',
  '奛',
  '寀',
  '岦',
  '嵂',
  '嶹',
  '悊',
  '惲',
  '憘',
  '抦',
  '撝',
  '晗',
  '暙',
  '暿',
  '桄',
  '﨓',
  '棏',
  '榘',
  '樰',
  '橆',
  '橾',
  '氿',
  '泚',
  '淏',
  '渧',
  '渼',
  '溿',
  '澵',
  '瀇',
  '炻',
  '焄',
  '犱',
  '獷',
  '皜',
  '砡',
  '硤',
  '礰',
  '禔',
  '禛',
  '竑',
  '竧',
  '綷',
  '荿',
  '蓜',
  '蕓',
  '蘒',
  '﨡',
  '誾',
  '譿',
  '賰',
  '﨤',
  '釚',
  '釮',
  '鈊',
  '鉎',
  '鉑',
  '鉙',
  '鉧',
  '銧',
  '鋐',
  '鋗',
  '鋙',
  '鋧',
  '鋹',
  '鋻',
  '錂',
  '錝',
  '錞',
  '鍗',
  '鑅',
  '隯',
  '靕',
  '髜',
  '鮱',
  '鵫',
  '鸙',
]
